import React, { memo } from "react";
import { useMediaQuery } from 'react-responsive'

export const AbleCource = memo((props) => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 760px)'});

  return (
    <>
      <div className="card">
        <div className="card-header bg-dark text-white">
          <b className="h4">受診可能コース </b>
          <i className="fas fa-exclamation-triangle text-warning">
          </i> あなたの受診区分は<b>【C】</b>です。
        </div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-md-3 g-4 accordion">
            <div className="col">
              <div className="card accordion-item h-100">
              {/* <div className="card accordion-item h-10g0 bg-secondary"> */}
                {/* <div className="card-header h5 accordion-header accordion-button js-sp-accordion-header bg-secondary" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> */}
                <div className={`card-header h5 accordion-header accordion-button js-sp-accordion-header ${isMobileScreen && 'collapsed'}`} id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b className="text-dark">人間ドックコース</b>
                </div>
                <div id="collapseOne" className={`card-body accordion-collapse collapse js-sp-accordion-hide ${isMobileScreen || 'show'}`} aria-labelledby="headingOne">
                  <b>オプション</b>
                  <ul>
                    <li>乳腺超音波検査</li>
                    <li>マンモグラフィ</li>
                    <li>子宮頸がん検査</li>
                    <li>腹部超音波検査</li>
                    <li>骨密度検査検査</li>
                  </ul>
                  上記5つの指定オプションより、オプション検査追加可能。
                  <hr />
                  胃部検査等の必須項目のキャンセルはできません。<br />
                  必須項目キャンセルご希望の方は事前に健康保険組合へご連絡をお願いいたします。<br />
                  朝日生命健康保険組合 03-4574-5018<br />
                  ※胃部検査キャンセル希望の方は、セレクト健診のご受診をご検討ください。
                </div>
                <div className="card-footer">補助上限の¥25,000超過分は自己負担となり、当日窓口支払です。</div>
              </div>
            </div>
            <div className="col">
              <div className="card accordion-item h-100">
                <div className={`card-header h5 accordion-header accordion-button js-sp-accordion-header ${isMobileScreen && 'collapsed'}`} id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                  <b className="text-dark">セレクト健診コース</b>
                </div>
                <div id="collapseTwo" className={`card-body accordion-collapse collapse js-sp-accordion-hide ${isMobileScreen || 'show'}`}>
                  <b>オプション</b>
                  <ul>
                    <li>乳腺超音波検査</li>
                    <li>マンモグラフィ</li>
                    <li>子宮頸がん検査</li>
                    <li>腹部超音波検査</li>
                    <li>骨密度検査検査</li>
                  </ul>
                  上記5つの指定オプションより、オプション検査追加可能。
                  <hr />
                  今年度より「便潜血反応検査」が必須項目となりました。<br />
                  必須項目のキャンセルはできません。
                </div>
                <div className="card-footer">補助上限の¥25,000超過分は自己負担となり、当日窓口支払です。</div>
              </div>
            </div>
            <div className="col">
              <div className="card accordion-item h-100">
                <div className={`card-header h5 accordion-header accordion-button js-sp-accordion-header ${isMobileScreen && 'collapsed'}`} id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                  <b className="text-dark">定期健診コース</b>
                </div>
                <div id="collapseThree" className={`card-body accordion-collapse collapse js-sp-accordion-hide ${isMobileScreen || 'show'}`}>
                  オプション検査追加不可。<br />
                  必須項目のキャンセルはできません。
                </div>
                <div className="card-footer">自己負担なし</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
});